import axios from 'axios'

export default axios.create({
  baseURL: 'https://erjan.timelysoft.org/api'
})
